import { render, staticRenderFns } from "./CommunityBusinessnewsDetail.vue?vue&type=template&id=11bae272&scoped=true&"
import script from "./CommunityBusinessnewsDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityBusinessnewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBusinessnewsDetail.vue?vue&type=style&index=0&id=11bae272&prod&scoped=true&lang=css&"
import style1 from "./CommunityBusinessnewsDetail.vue?vue&type=style&index=1&id=11bae272&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bae272",
  null
  
)

export default component.exports